const header = document.querySelector(".landing-nav");
const landingBtn = document.querySelector("#landingBtn");
const sectionOne = document.querySelector(".hero");
const hammyBtn = document.querySelector("#hammyBtn");

sectionOneOptions = {};

const sectionOneObserver = new IntersectionObserver(function (
  entries,
  sectionOneObserver
) {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) {
      header.classList.add("sticky");
      landingBtn.classList.remove("btn-white");
      landingBtn.classList.add("btn-primary");
      hammyBtn.classList.add("sticky-is-stuck");
    } else {
      header.classList.remove("sticky");
      landingBtn.classList.add("btn-white");
      landingBtn.classList.remove("btn-primary");
      hammyBtn.classList.remove("sticky-is-stuck");
    }
  });
},
sectionOneOptions);

sectionOneObserver.observe(sectionOne);
